


















































import Vue from 'vue';
import axios from '@/plugins/axios';
import { API_SEARCH_TOKUISAKI } from '@/constants/api';
import CtrlNumTxt from '@/components/common/control/CtrlNumTxt.vue';
import CtrlSearchBtn from '@/components/common/control/CtrlSearchBtn.vue';
import ListTokuisaki from '@/components/common/search/ListTokuisaki.vue';
import { noDataError, clearNoDataError } from '@/utils/message';
import { SeikyusakiKb, TaishoFlg } from '@/constants/constants';

export default Vue.extend<any, any, any, any>({
  name: 'CtrlTokuisaki',
  components: {
    CtrlNumTxt,
    CtrlSearchBtn,
    ListTokuisaki,
  },
  props: {
    jigyoshoCd: {
      type: Number,
      default: 0,
    },
    seikyusakiKb: {
      type: Number,
      required: true,
    },
    targetYmd: {
      type: Number,
      required: true,
    },
    gyoshuCd: {
      type: Number,
    },
    mukoUmuFlg: {
      type: Number,
    },
    jigyoshoHenkoFlg: {
      type: Boolean,
      default: false,
    },
    initialDataSearch: {
      type: Boolean,
      default: false,
    },
    callbackCancel: {
      type: Function,
    },
    callbackOk: {
      type: Function,
    },
    label: {
      type: String,
      default: '',
    },
    widthCd: {
      type: Number,
      default: 84,
    },
    widthName: {
      type: Number,
      default: 340,
    },
    required: {
      type: Boolean,
      default: false,
    },
    readonly: {
      type: Boolean,
      default: false,
    },
    tokenCheckFlg: {
      type: Number,
    },
    riyoshaTokuisakiTaishoFlg: {
      type: Number,
    },

  },
  data: () => ({
    SeikyusakiKb,
    API_SEARCH_TOKUISAKI,
    listTokuisaki: false,
    tokuisakiCd: 0,
    tokuisakiRyakuMei: '',
    errors: {
      errorMessages: '',
    },
    isNoData: false,
  }),
  computed: {
    styleItemName() {
      return {
        whiteSpace: 'nowrap',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        width: `${this.widthName}px`,
        color: 'rgba(0, 0, 0, 0.87)',
        cursor: 'default',
      };
    },
  },
  methods: {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    handleOk(item: any) {
      const { tokuisakiCd, tokuisakiRyakuMei } = item;
      this.tokuisakiCd = tokuisakiCd;
      this.tokuisakiRyakuMei = tokuisakiRyakuMei;
      this.listTokuisaki = false;
      this.errors.errorMessages = '';
      this.callbackOk && this.callbackOk(item);
      this.isNoData = false;
    },
    handleCancel() {
      this.listTokuisaki = false;
      this.callbackCancel && this.callbackCancel();
    },
    handleChange(value: number) {
      this.tokuisakiCd = value;
      if (value) {
        this.getTokuisakiItem();
      } else {
        this.tokuisakiRyakuMei = '';
        this.errors = clearNoDataError();
        // IDをクリアするとデータをリセットする
        this.callbackOk && this.callbackOk({ tokuisakiCd: this.tokuisakiCd });
      }
    },
    getTokuisakiItem() {
      // 必須 parameter
      let params: any = {
        tokuisakiCd: `${this.tokuisakiCd}`,
        jigyoshoCd: `${this.jigyoshoCd}`,
        seikyusakiKb: `${this.seikyusakiKb}`,
        targetYmd: `${this.targetYmd}`,
      };

      // 任意parameter
      if (this.gyoshuCd) {
        params.gyoshuCd = this.gyoshuCd;
      }
      if (this.mukoUmuFlg) {
        params.mukoUmuFlg = this.mukoUmuFlg;
      }
      if (this.tokenCheckFlg) {
        params.tokenCheckFlg = this.tokenCheckFlg;
      }
      if (this.riyoshaTokuisakiTaishoFlg) {
        params.riyoshaTokuisakiTaishoFlg = TaishoFlg.TAISHO_GAI;
      } else {
        params.riyoshaTokuisakiTaishoFlg = TaishoFlg.TAISHO;
      }
      axios
        .get(API_SEARCH_TOKUISAKI, {
          params: params,
        })
        .then((res) => {
          if (!res.data.responseData || res.data.responseData.length === 0) {
            this.tokuisakiRyakuMei = '';
            this.isNoData = true;
            this.errors = noDataError();
            this.callbackOk &&
              this.callbackOk({ tokuisakiCd: this.tokuisakiCd });
            return;
          }
          this.errors = clearNoDataError();
          const { tokuisakiRyakuMei } = res.data.responseData[0];
          this.tokuisakiRyakuMei = tokuisakiRyakuMei;
          this.callbackOk && this.callbackOk(res.data.responseData[0]);
          this.isNoData = false;
        });
    },
  },
  watch: {
    //呼び出し元の tag の 引数 [tokuisakiCd] に bind している変数 を監視する
    // 変数が、input 以外の event で値変更された時に、その値を control に set
    '$attrs.tokuisakiCd': {
      handler(newValue) {
        if (+newValue === +this.tokuisakiCd) return;
        this.tokuisakiCd = +newValue;
        if (newValue) {
          this.getTokuisakiItem();
        } else {
          this.tokuisakiRyakuMei = '';
          this.errors = clearNoDataError();
        }
      },
    },
  },
  created() {
    if (this.$attrs.tokuisakiCd) {
      this.tokuisakiCd = +this.$attrs.tokuisakiCd;
    }
  },
});
